import {
  CalendarCheck, ListChecks, Megaphone, MapPin, Star, Compass,
  Building2, LayoutGrid, Sparkles, TrendingUp, Handshake, LifeBuoy,
  Home, Globe2, MessageSquare, LineChart, Lock, UserCheck, ShieldCheck, FileCheck,
} from "lucide-react";

const map = {
  CalendarCheck, ListChecks, Megaphone, MapPin, Star, Compass,
  Building2, LayoutGrid, Sparkles, TrendingUp, Handshake, LifeBuoy,
  Home, Globe2, MessageSquare, LineChart, Lock, UserCheck, ShieldCheck, FileCheck,
};

export const Icon = ({ name, className }) => {
  const Cmp = map[name] || Sparkles;
  return <Cmp className={className} />;
};
